import { NgModule } from "@angular/core";

import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { WmComponentsModule } from '@wm/components-base';
import { CarouselModule as ngxCarouselModule} from 'ngx-bootstrap/carousel';
import {CarouselModule} from "./components/widgets/advanced/carousel/carousel.module";
import { CustomWidgetModule } from "./components/widgets/advanced/custom-widget/custom-widget.module"

@NgModule({ exports: [
        WmComponentsModule,
        CarouselModule,
        CustomWidgetModule
    ], imports: [WmComponentsModule,
        CarouselModule,
        CustomWidgetModule,
        ngxCarouselModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class RuntimeBaseModule { }
